const Industry = ({img, desc}) => {
    return (
        <div className="industry">
            <img src={img} alt="Industry" />
            <p>{desc}</p>
        </div>
    )
}

export default Industry;